module.exports = __webpack_public_path__ + "img/thumbnail_SiberianTiger_f_leucistic.dd6f63cd.png";